import PropTypes from "prop-types";
import React from "react";
import clsx from "clsx";
import styles from "./Loading.module.scss";

const Spinner = (props) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" {...props}>
    <path
      d="m27.9 27.9 1.8 1.8 1.4-1.8a3 3 0 0 0-3.2 0Zm-2.7 1.8 1 2.3c1.3-.5 2.5-1.3 3.5-2.3l-1.8-1.8-.4.3a8 8 0 0 1-2.3 1.5Zm-3.2.6v2.6c1.5 0 3-.3 4.2-.9l-1-2.3c-1 .4-2 .6-3.2.6Zm-3.2-.6-1 2.3a10.7 10.7 0 0 0 4.2.9v-2.6h-.6c-1-.1-1.8-.3-2.6-.6Zm-2.6-1.8-1.8 1.8c1 1 2.2 1.8 3.5 2.3l1-2.3c-1-.5-2-1-2.7-1.8Zm-1.8-2.7-2.4 1c.6 1.3 1.4 2.5 2.4 3.5l1.8-1.8a8.7 8.7 0 0 1-1.8-2.7Z"
      fill="url(#a)"
    />
    <path
      d="M13.7 22h-2.6v.6c.1 1.3.4 2.5.9 3.6l2.4-1a8.3 8.3 0 0 1-.7-3.2Zm.7-3.2-2.4-1A11 11 0 0 0 11 22h2.6c0-1.1.3-2.2.7-3.2Zm1.8-2.6-1.9-1.9A11 11 0 0 0 12 18l2.4 1c.4-1 1-2 1.8-2.7Zm1.6-4.2a11 11 0 0 0-3.5 2.3l1.8 1.9c.8-.8 1.7-1.4 2.7-1.8l-1-2.4Z"
      fill="url(#b)"
    />
    <path
      d="m18.8 14.4-1-2.4A11 11 0 0 1 22 11v2.6c-1.1 0-2.2.3-3.2.7Zm7.4-2.4c-1.3-.6-2.7-.9-4.2-.9v2.6c1.1 0 2.2.2 3.2.6l1-2.3Zm-1 2.3 1-2.4a11 11 0 0 1 3.5 2.4l-1.8 1.8a8.4 8.4 0 0 0-2.8-1.8Zm4.5 0L27.8 16a8.4 8.4 0 0 1 2.5 5.3l-.8-.8c-.5-.5-1.3-.6-1.8-.2-.6.6-.6 1.4-.1 2l2.7 2.7c.8.7 1.9.7 2.6 0l2.7-2.7c.4-.5.5-1.2.1-1.7-.5-.7-1.4-.7-1.9-.2l-1 1c0-2.8-1.3-5.4-3.1-7.2Z"
      fill="url(#c)"
    />
    <defs>
      <linearGradient id="a" x1="30.6" y1="27.7" x2="13.4" y2="25.6" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFBDA8" stopOpacity="0" />
        <stop offset="1" stopColor="#D06096" stopOpacity=".5" />
      </linearGradient>
      <linearGradient id="b" x1="13.4" y1="25.6" x2="10.8" y2="14.4" gradientUnits="userSpaceOnUse">
        <stop stopColor="#D06096" stopOpacity=".5" />
        <stop offset="1" stopColor="#9A5CF2" />
      </linearGradient>
      <linearGradient id="c" x1="16.8" y1="14.4" x2="34" y2="23" gradientUnits="userSpaceOnUse">
        <stop stopColor="#9A5CF2" />
        <stop offset="1" stopColor="#3CCFFF" />
      </linearGradient>
    </defs>
  </svg>
);

export const Loading = ({ className, size }) => {
  // we will use this to prevent having an error in existing sizing in the current application like "ExtraSmall" to "extraSmall"
  const loadingSize = size && size.charAt(0).toLowerCase() + size.slice(1);

  const containerClasses = clsx(
    "d-flex flex-row justify-content-center",
    styles.loading,
    className,
    {
      [styles[loadingSize]]: size,
    }
  );

  const spinnerClasses = clsx("d-flex align-items-center justify-content-center", styles.circle);

  return (
    <div className={containerClasses} data-testid="Loading">
      <div className={spinnerClasses}>
        <LoadingSpinner size={size} />
      </div>
    </div>
  );
};

export const LoadingSpinner = ({ size }) => {
  // we will use this to prevent having an error in existing sizing in the current application like "ExtraSmall" to "extraSmall"
  const loadingSize = size && size.charAt(0).toLowerCase() + size.slice(1);

  const loadingClasses = clsx(styles.loadingSpinner, {
    [styles[loadingSize]]: size,
  });

  return (
    <div className={loadingClasses} data-testid="LoadingSpinner">
      <Spinner />
    </div>
  );
};

const SIZES = ["Medium", "Small", "ExtraSmall"];

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(SIZES),
};

Loading.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(SIZES),
};

export const withLoader =
  (WrappedComponent) =>
  ({ isComponentLoading, ...props }) => {
    return <>{isComponentLoading ? <Loading /> : <WrappedComponent {...props} />}</>;
  };

export default Loading;
